import api from './api';

export const getFilterPresets = async (viewKey) => {
  const response = await api.get('/api/private/user/filter-presets', {
    params: { viewKey },
  });
  return response.data;
};

export const getDefaultFilterPreset = async (viewKey) => {
  const response = await api.get('/api/private/user/filter-presets/default', {
    params: { viewKey },
  });
  if (response.status === 204 || !response.data) {
    return null;
  }
  return response.data;
};

export const createFilterPreset = async (payload) => {
  const response = await api.post('/api/private/user/filter-presets', payload);
  return response.data;
};

export const updateFilterPreset = async (id, payload) => {
  const response = await api.put(`/api/private/user/filter-presets/${id}`, payload);
  return response.data;
};

export const setDefaultFilterPreset = async (id) => {
  const response = await api.put(`/api/private/user/filter-presets/${id}/default`);
  return response.data;
};

export const deleteFilterPreset = async (id) => {
  await api.delete(`/api/private/user/filter-presets/${id}`);
};
